  <mat-card class="cardTable mat-elevation-z3">
    <mat-card-title class="title"> Versão 1 Utilizando o MongoDB</mat-card-title>
  </mat-card>

<button mat-raised-button routerLink="/tabelacreate" class="cadastrar" color="primary">
  Cadastrar Animal
</button>

<button mat-raised-button class="cardFiltro" color="primary" (click)="this.open()">{{this.isOpen ? "-" : "+" }} Filtrar Animal </button>

<!-- FILTRAR PELO FRONT -->
<mat-form-field  *ngIf="this.isOpen" class="formfiltro">
  <mat-card  class="cardTable2 mat-elevation-z3">
    <mat-card-title class="title"> Um dia Rola um filtro kkkkk </mat-card-title>
  </mat-card>
    <!-- <mat-label class="label">Filtrar</mat-label> -->
    <!-- <input matInput (keyup)="filter($event)" placeholder="Ex: Gato" #input> -->
</mat-form-field>

<table mat-table *ngIf="this.tabelaAnimal?.animais" [dataSource]="tabelaAnimal?.animais" class="mat-elevation-z8">  
 
  <!-- Name Column -->
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let row">{{row.nome}}</td>
  </ng-container>

  <!-- Especie Column -->
  <ng-container matColumnDef="especie">
    <th mat-header-cell *matHeaderCellDef>Espécie</th>
    <td mat-cell *matCellDef="let row">{{row.especie}}</td>
  </ng-container>

   <!-- Local Column -->
   <ng-container matColumnDef="local">
    <th mat-header-cell *matHeaderCellDef>Local</th>
    <td mat-cell *matCellDef="let row">{{row.local}}</td>
  </ng-container>

    <!-- Action Column-->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Ações</th>
      <td mat-cell *matCellDef="let row">
          <a  routerLink="/tabelaupdate/{{row._id}}" class="edit">
              <i class="material-icons"> 
                  edit
              </i>
          </a>

          <a routerLink="/tabeladelete/{{row._id}}" class="delete">
              <i class="material-icons">
                  delete
              </i>
          </a>
      </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>>